import {setGlobalDevModeChecks} from 'reselect';

/**
 * Redux Toolkit 2 ships reselect 5, whose development checks flag many existing core selectors
 * (`identityFunctionCheck`); RTK 1.9 (legacy brands) never ran them. Keep the logs readable until
 * those selectors are refactored.
 */
setGlobalDevModeChecks({identityFunctionCheck: 'never'});
